import { privateAxios } from "../axios";
import {
	CreateBrokerContactBody,
	CreateDuneContactBody,
	CreateInsurerContactBody,
	CreateSyndicContactBody,
	CreateTPAContactBody,
	UpdateContactBody,
} from "../types/contacts/contacts.types";

export const createBrokerContact = async (body: CreateBrokerContactBody) => {
	const { data } = await privateAxios.post("/contacts/create-broker", body);
	return data;
};

export const createSyndicContact = async (body: CreateSyndicContactBody) => {
	const { data } = await privateAxios.post("/contacts/create-syndic", body);
	return data;
};

export const createDuneContact = async (body: CreateDuneContactBody) => {
	const { data } = await privateAxios.post("/contacts/create-dune", body);
	return data;
};

export const createInsurerContact = async (body: CreateInsurerContactBody) => {
	const { data } = await privateAxios.post("/contacts/create-insurer", body);
	return data;
};

export const createTPAContact = async (body: CreateTPAContactBody) => {
	const { data } = await privateAxios.post("/contacts/create-tpa", body);
	return data;
};

export const updateContact = async (
	contactId: number,
	body: UpdateContactBody,
) => {
	const { data } = await privateAxios.patch(`/contacts/${contactId}`, body);
	return data;
};

export const deleteContact = async (contactId: number) => {
	await privateAxios.delete(`/contacts/${contactId}`);
};
